import * as yup from 'yup'

export const DateOfBirthValidation = yup
  .string()
  .typeError('Please enter a date of birth')
